import { Spinner } from '@opaz/ui-components';
import { useTranslation } from 'react-i18next';

export const TaskPaymentLoading = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center">
      <Spinner className="w-20 h-20 mb-12" />

      <div className="flex flex-col items-center gap-6">
        <span className="font-bold text-2xl">{t('payment.loadingTitle')}</span>
        <span className="text-xl">{t('payment.loadingSubtitle')}</span>
      </div>
    </div>
  );
};
